export default function Unauthorized() {
  return (
    <div>
      <h1>Sorry, your account is not authorized to see this page.</h1>
      <a href="/">Logout link</a>
    </div>
  );
}
